// plotOptions that report a clicked point to `onPointClick`, for charts that drill down into
// their transactions. `x` is a category chart's category index, `index` a pie slice's.
export const drillDownPlotOptions = (onPointClick) =>
  onPointClick
    ? {
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click: function () {
                onPointClick({ x: this.x, index: this.index, seriesName: this.series.name })
              }
            }
          }
        }
      }
    : {}
